import React, { Component } from 'react';
import img from '../images/BISTRO2.png'
import {auth, firebase} from '../firebase';
import {Alert} from 'react-bootstrap'
import axios from 'axios'
import moment from 'moment'
import button_img from '../images/buttonn.png'
import BistroPhone from '../images/BistroPhone.png'
import step1 from '../images/step1.jpg'
import step2 from '../images/step2.jpg'
import step3 from '../images/step3.jpg'
import Notification from 'rc-notification';
import 'rc-notification/assets/index.css';
import ModalConnection from './ModalConnectionSubscribe';
import {doSignOut} from '../authDB';


// id dev
//const idRestaurant="-LHCvfvi5Zis0rJffGlg"
// id prod
const idRestaurant="-L8HPl47r9qChaUm_6uU"


var validator = require("email-validator");

let notification = null;
Notification.newInstance({}, (n) => notification = n);

class App extends Component {

    constructor(){
        super()
        this.state={
            email:"",
            success:false,
            email1:"",
            name:"",
            time:"",
            personnes:"",
            date:"",
            phone:"",
            special:{},
            days:"",
            start_time:"",
            end_time:"",
            blog:[]

        }
    }
    show_connection(){
        this.refs.ModalConnection.handleShow();
    console.log(this.refs)
    }
    Deconx(){
      localStorage.removeItem('user')
      doSignOut().then(()=>{
        window.parent.location = window.parent.location.href;
    
      })
    }
    componentDidMount(){

        var ref_blog= firebase.database().ref(`/blog/${idRestaurant}`);

        ref_blog.orderByChild('created_at').limitToLast(3).on("value",(data)=>{
            console.log(data.val())
this.setState({blog:data.val()})
      
          })


        var ref_blog= firebase.database().ref(`/products/${idRestaurant}`);
        var ref_schedules=firebase.database().ref(`/stores_schedules/${idRestaurant}`);

        ref_blog.orderByChild("is_special_today").equalTo(true).on("child_added",(data)=>{
            console.log(data.val())
            this.setState({special:data.val()})
      
          })
          ref_blog.orderByChild("is_special_today").equalTo(true).on("child_changed",(data)=>{
            console.log(data.val())
            this.setState({special:data.val()})
      
          })

          ref_schedules.on("value",(data)=>{
          
this.setState({schedules:data.val()})

          })

    }
send(){
if(validator.validate(this.state.email)){
    var newsletter= firebase.database().ref(`/newsletter/`);
newsletter.push({email:this.state.email,id_restaurant: idRestaurant}).then(()=>{this.setState({email:"",success:true})})

}else{
   // alert("email invalide")
    notification.notice({
        content: <span style={{fontSize:20}}><i class="fa fa-warning" style={{fontSize:20,color:'red',marginRight:20}}></i>Email invalide</span>, 
        duration: 5,
        onClose() {
          console.log('closable close');
        },
        closable: true,
      });
}
}
reserver(){
    var that=this
    if(this.state.email1&& this.state.phone&& this.state.date&& this.state.name 
        && this.state.personnes && this.state.time)
    {axios.get('https://intense-reaches-19510.herokuapp.com/reservation', {
        params: {
            personnes:this.state.personnes,
            email:this.state.email1,
            time:this.state.time,
            date:this.state.date,
            phone:this.state.phone,
            name:this.state.name






        }
      })
      .then(function (response) {
          that.setState({
            personnes:"",
            email1:"",
            time:"",
            date:"",
            phone:"",
            name:""
          })
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
       // alert("error")
       notification.notice({
        content: <span style={{fontSize:20}}><i class="fa fa-warning" style={{fontSize:20,color:'red',marginRight:20}}></i>Erreur</span>, 
        duration: 5,
        onClose() {
          console.log('closable close');
        },
        closable: true,
      });
      });}
      else
      {
      //  alert("champs vide")
        notification.notice({
            content: <span style={{fontSize:20}}><i class="fa fa-warning" style={{fontSize:20,color:'red',marginRight:20}}></i>Champs Vide</span>, 
            duration: 5,
            onClose() {
              console.log('closable close');
            },
            closable: true,
          });
      }

}


blog_list(){
    var items=[]
   Object.keys(this.state.blog||[]).forEach((v,e)=>{
   
       items.push(  <div className="col-md-4 col-sm-6">
       <div className="blog">
           <div className="featured-pic">
               <a href={"/detail/"+v}>
                   <img src={this.state.blog[v].image.url} alt="blog pic" className="img-responsive"/>
               </a>
           </div>
   
           <div className="content">
               <ul className="meta">
                   <li>
                       <i className="fa fa-calendar"></i>{moment(this.state.blog[v].created_at).format('LL')}
                   </li>
                 
               </ul>
               <h4 className="blog-title  txt-hover">
                   <a href={"/detail/"+v}> {this.state.blog[v].title}</a>
               </h4>
               <p>
                   {this.state.blog[v].body.substring(0,145)+" ..."
   }
                   </p>
               <a href={"/detail/"+v} className="btn-secondry">Plus de Details</a>
           </div>
       </div>
   </div>)

   
   
   })
   
   
   
    return items
           
       }

 retournez(s){
     var items=[]
     var tab=(s||"").split("\n")
     for(var i=0;i<tab.length;i++){
         items.push(<div> {tab[i]}  <br/>  </div> )
     }
     return items
 }



  render() {
      var schedules=this.state.schedules
      var start_time=""
      var  selectedDays=[]
      var id=""
   var end_time=""
    Object.keys(schedules||[]).forEach((sch, i) =>{
        //console.log(sch)
        //console.log(i)
         selectedDays = schedules[sch].days.split(',')
         id=sch
         start_time=schedules[sch].start_time
         end_time=schedules[sch].end_time

         console.log(start_time)
         console.log(end_time)
       // console.log(selectedDays)
    })

    const days = ["monday","tuesday","wednesday","thursday","friday","saturday","sunday"]
    const formatd = { "monday":`Lundi`, "tuesday":`Mardi`, "wednesday":`Mercredi`, "thursday":`Jeudi`, "friday":`Vendredi`, "saturday":`Samedi` , "sunday":`Dimanche` };
    var x = new Date();
     var currentTimeZoneOffsetInHours = x.getTimezoneOffset() / 60;
     console.log(currentTimeZoneOffsetInHours)
   var daysi  =""
   
        const format = 'HH:mm';
        const format2 = 'h:mm A';
       
       daysi=formatd[selectedDays[0]]
       for(var i=1;i<selectedDays.length;i++)
   {
       daysi=daysi+", "+formatd[selectedDays[i]]
      
   }
   start_time=moment(start_time, format2).subtract(currentTimeZoneOffsetInHours,'h')
   end_time=moment(end_time, format2).subtract(currentTimeZoneOffsetInHours,'h')
    start_time=start_time.format(format)
    end_time=end_time.format(format)


    

        //var stmoment(, format).subtract(currentTimeZoneOffsetInHours,'h')
    return (
   <div>
       
       <header className="header">
            <div className="container">
                <div className="menubar">
                    <div className="row">
                        <div className="col-md-12">
                            <nav className="navbar navbar-static-top">
                             <div className="navbar-header">
                                    <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" aria-expanded="false">
                                        <span className="sr-only">Toggle navigation</span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                    </button>
                                    <a className="navbar-brand" href="/">
                                        <img src="/images/logo.png" className="img-responsive" alt="logo"/>
                                    </a>
                                </div>                      
     <div className="collapse navbar-collapse ">
                                    <ul className="nav navbar-nav navbar-right">
                                    
                                    <li className="res-btn">
                                          {(JSON.parse(localStorage.getItem('user')))?  <button onClick={()=>this.Deconx()} className="book-btn">Déconnection</button>:<button onClick={()=>this.show_connection()} className="book-btn">Connexion</button>}
                                    </li>
                                    </ul>
                                    <ul className="nav navbar-nav navbar-right" id="main-menu">

                                    <li className="active">

                                         <a  href="/">
                                                Accueil
                                         </a>
                                    </li>
                                    {/*    <li className="">
                                            <a  href="/about">À propos</a>
    </li>*/}
                                        <li className="">
                                            <a  href="/order">Menu</a>                                          
                                        </li>
                                        {(JSON.parse(localStorage.getItem('user')))?  <li className="">
                                            <a  href="/historique">Historique</a>
                                        </li>:null       }     
                                        {(JSON.parse(localStorage.getItem('user')))?   <li className="">
                                            <a href="/loyalty">
                                            Fidélité
                                            </a>
                                        </li>  :null       } 
                                        <li className="">
                                            <a   href="/Blog">
                                                Blog
                                            </a>
                                        </li>     
                                                          
                                        <li className="">
                                            <a   href="/contact">
                                                Contact
                                            </a>
                                        </li>  
                                                                           
                                    </ul>
                                </div>  
                            </nav>
                        </div>
                    </div>
                </div>

            </div>
            <div className="mobile-menu" data-logo="/images/logo.png">


            </div>



        </header>

        <section className="sliders">
            <div className="testy-slider owl-carousel" data-items="1" data-loop="true"  data-autoplay="true"  data-smart-speed="400" data-dots="true" data-nav="true"
                 data-r-x-small="1" data-r-x-small-nav="true" data-r-x-small-dots="true" data-r-x-medium="1" data-r-x-medium-nav="false"
                 data-r-x-medium-dots="true" data-r-small="1" data-r-small-nav="true" data-r-small-dots="true" data-r-medium="1"
                 data-r-medium-nav="true" data-r-medium-dots="false" data-r-large="1" data-r-large-nav="true" data-r-large-dots="false">

                <div className="item">
                    <img src="images/slider.jpg" alt="slider image"/>
                
                    <div className="container">
                
                        <div className="slider-text">
                       
                            <h2>
                               Bienvenue à
                                <span> Bistro 73</span>
                            </h2>
                            <p className="slide-desc">Bistro 73, une merveille de plaisir et de bon goût.</p>
                            <a href="/order"  className="btn-custom">Commandez Maintenant</a>
                           
                            <a href="#special"  > <img src={button_img} style={{  marginTop:20,  height: 40
,    width: 184}}  /> </a>

 <div className="hours-box">
                                <h3> Horaires</h3>

                                <div className="row">
                                <div className="col-xs-12">
                                        <div className="hours">
                                            <div className="icon">
                                                <i className="fa fa-clock-o"></i>
                                            </div>
                                           
                                            <p className="hours-text">{start_time} - {end_time}</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-12">
                                        <div className="hours">
                                            <div className="icon">
                                                <i className="fa fa-calendar	"></i>
                                                

                                            </div>
                                            <h4 className="hours-title">{daysi}</h4>
                                            
                                        </div>
                                    </div>
                                  


                                 
                                  
                                </div>
                            </div>
                            

                       

                        </div>
                    </div>
                </div>
                <div className="item">
                    <img src="images/Bistro1.jpg" alt="slider image"/>
                
                    <div className="container">
                
                        <div className="slider-text">
                       
                            <h2>
                               Bienvenue à
                                <span> Bistro 73</span>
                            </h2>
                            <p className="slide-desc">Bistro 73, une merveille de plaisir et de bon goût.</p>
                            <a href="/order"  className="btn-custom">Commandez Maintenant</a>
                           
                            <a href="#special"  > <img src={button_img} style={{  marginTop:20,  height: 40
,    width: 184}}  /> </a>

 <div className="hours-box">
                                <h3> Horaires</h3>

                                <div className="row">
                                <div className="col-xs-12">
                                        <div className="hours">
                                            <div className="icon">
                                                <i className="fa fa-clock-o"></i>
                                            </div>
                                           
                                            <p className="hours-text">{start_time} - {end_time}</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-12">
                                        <div className="hours">
                                            <div className="icon">
                                                <i className="fa fa-calendar	"></i>
                                                

                                            </div>
                                            <h4 className="hours-title">{daysi}</h4>
                                            
                                        </div>
                                    </div>
                                  


                                 
                                  
                                </div>
                            </div>
                            

                       

                        </div>
                    </div>
                </div>
                <div className="item">
                    <img src="images/Bistro2.jpg" alt="slider image"/>
                
                    <div className="container">
                
                        <div className="slider-text">
                       
                            <h2>
                               Bienvenue à
                                <span> Bistro 73</span>
                            </h2>
                            <p className="slide-desc">Bistro 73, une merveille de plaisir et de bon goût.</p>
                            <a href="/order"  className="btn-custom">Commandez Maintenant</a>
                           
                            <a href="#special"  > <img src={button_img} style={{  marginTop:20,  height: 40
,    width: 184}}  /> </a>

 <div className="hours-box">
                                <h3> Horaires</h3>

                                <div className="row">
                                <div className="col-xs-12">
                                        <div className="hours">
                                            <div className="icon">
                                                <i className="fa fa-clock-o"></i>
                                            </div>
                                           
                                            <p className="hours-text">{start_time} - {end_time}</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-12">
                                        <div className="hours">
                                            <div className="icon">
                                                <i className="fa fa-calendar	"></i>
                                                

                                            </div>
                                            <h4 className="hours-title">{daysi}</h4>
                                            
                                        </div>
                                    </div>
                                  


                                 
                                  
                                </div>
                            </div>
                            

                       

                        </div>
                    </div>
                </div> <div className="item">
                    <img src="images/Bistro3.jpg" alt="slider image"/>
                
                    <div className="container">
                
                        <div className="slider-text">
                       
                            <h2>
                               Bienvenue à
                                <span> Bistro 73</span>
                            </h2>
                            <p className="slide-desc">Bistro 73, une merveille de plaisir et de bon goût.</p>
                            <a href="/order"  className="btn-custom">Commandez Maintenant</a>
                           
                            <a href="#special"  > <img src={button_img} style={{  marginTop:20,  height: 40
,    width: 184}}  /> </a>

 <div className="hours-box">
                                <h3> Horaires</h3>

                                <div className="row">
                                <div className="col-xs-12">
                                        <div className="hours">
                                            <div className="icon">
                                                <i className="fa fa-clock-o"></i>
                                            </div>
                                           
                                            <p className="hours-text">{start_time} - {end_time}</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-12">
                                        <div className="hours">
                                            <div className="icon">
                                                <i className="fa fa-calendar	"></i>
                                                

                                            </div>
                                            <h4 className="hours-title">{daysi}</h4>
                                            
                                        </div>
                                    </div>
                                  


                                 
                                  
                                </div>
                            </div>
                            

                       

                        </div>
                    </div>
                </div>
            </div>
            
        </section>
   
        <section className="about-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-md-6 hidden-sm hidden-xs">
                        <div className="chef-figure">
                            <img src="images/abt-chef.png" alt="about chef pic" className="img-responsive"/>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-xs-11 col-xs-offset-1">
                                <h2 className="main-title text-right">
                                    <span className="bg-reverse"> À propos de Nous</span>
                                </h2>
                            </div>
                        </div>
                        <div className="abt-content">
                            <p>
                            Bistro 73, une merveille de plaisir et de bon goût.                            </p>
                            <p>
                            Bistro 73 est un lieu unique en son genre, le premier endroit totalement non-fumeur de Sousse, un Restaurant Buffet et à la carte, une Boulangerie pâtisserie « à la française » et un café où la qualité, le bon accueil et la propreté sont les maitres mots! Vous êtes les bienvenus chez vous.
                         </p>

                            <div className="abt-quality">
                                <div className="row">
                                    <div className="col-xs-6 sm-full sm-text-center">
                                        <div className="quality-box">
                                            <div className="icon">
                                                <i className="flaticon-tray-1"></i>
                                            </div>

                                            <h4 className="quality-title">
                                                <a href="#">Restaurant</a>
                                            </h4>
                                            <p>
                                            Le premier et seul restaurant en buffet, self-service et à la carte de la ville, une cuisine internationale avec une touche tunisienne pour sublimer le tout.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-xs-6 sm-full sm-text-center">
                                        <div className="quality-box">
                                            <div className="icon">
                                                <i className="flaticon-chef"></i>
                                            </div>

                                            <h4 className="quality-title">
                                                <a href="#">Boulangerie</a>
                                            </h4>
                                            <p>
                                            Une tradition perpétrée depuis plus de 30 ans, dans le respect total des procédés de panification « à la française ». Nous vous offrons, définitivement, le meilleur pain de la ville.                                            </p>

                                        </div>
                                    </div>
                                    <div className="col-xs-6 sm-full sm-text-center">
                                        <div className="quality-box">
                                            <div className="icon">
                                                <i className="flaticon-cake"></i>
                                            </div>

                                            <h4 className="quality-title">
                                                <a href="#">Pattiserie</a>
                                            </h4>
                                            <p>
                                            Des créations uniques et un sens inégalé de la qualité. Chez nous, aucun compromis n’est fait sur les produits. Vous méritez ce qu’il y a de mieux!
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
      
        <section className="service-section service-bg section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-md-5 col-xs-11">
                        <h2 className="main-title text-left">
                            <span>Services</span>
                        </h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <div className="row">
                            <div className="col-sm-6 col-md-12">
                                <div className="service">
                                    <div className="icon">
                                        <i className="flaticon-cake"></i>
                                    </div>
                                    <h4 className="service-title">Gâteaux personnalisés</h4>
                                  
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-12">
                                <div className="service">
                                    <div className="icon">
                                        <i className="fa fa-futbol-o"></i>
                                    </div>
                                    <h4 className="service-title"> Evénements Sportif</h4>
                                    
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-12">
                                <div className="service">
                                    <div className="icon">
                                        <i className="fa fa-motorcycle"></i>
                                    </div>
                                    <h4 className="service-title"> Livraison et commandes</h4>
                                    
                                </div>
                            </div>
                            	

                        </div>

                    </div>
                    <div className="col-md-6">
                        <div className="service-chef-figure">
                            <img src="images/service-chef.png" className="img-responsive" alt="service chef"/>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="row">
                            <div className="col-sm-6 col-md-12">
                                <div className="service">
                                    <div className="icon">
                                        <i className="	fa fa-hourglass-2"></i>
                                    </div>
                                    <h4 className="service-title">Happy Hour : De 15h jusqu'à 18h</h4>
                                
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-12">
                                <div className="service">
                                    <div className="icon">
                                        <i className="flaticon-table"></i>
                                    </div>
                                    <h4 className="service-title"> Fête d'anniversaire</h4>
                                   
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-12">
                                <div className="service">
                                    <div className="icon">
                                        <i className=" fa fa-plug"></i>
                                    </div>
                                    <h4 className="service-title">Recharge USB à table</h4>
                                   
                                </div>
                            </div>


                           	

                        </div>


                    </div>
                </div>
            </div>
        </section>
      
       
      
        <section className="blog-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <h2 className="main-title text-left">
                            <span className="bg-reverse"> Notre Blog</span>
                        </h2>
                    </div>
                </div>
                <div className="row center-grid">
                   {this.blog_list()}
                </div>
            </div>
        </section>
       
        <section className="call-out-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-md-10">
                        <h2>Découvrez le vrai goût de nos Plats.</h2>
                    </div>
                    <div className="col-md-2">
                        <div className="call-out-btn">
                            <a href="/contact" className="btn-custom">Contactez nous</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    
        <section className="testimonial-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-md-6 col-md-offset-6">
                        <h2 className="main-title text-right">
                            <span className="bg-reverse">Avis</span>
                        </h2>
                    </div>
                </div>
                <div className="testy-slider testimonial-slider owl-carousel" data-items="2" data-margin="30" data-loop="true" data-smart-speed="400"
                     data-dots="false" data-nav="true" data-r-x-small="1" data-r-x-small-nav="true" data-r-x-small-dots="false"
                     data-r-x-medium="1" data-r-x-medium-nav="false" data-r-x-medium-dots="false" data-r-small="1" data-r-small-nav="true"
                     data-r-small-dots="false" data-r-medium="2" data-r-medium-nav="true" data-r-medium-dots="false" data-r-large="2"
                     data-r-large-nav="true" data-r-large-dots="false">
                    <div className="item">
                        <div className="testimonial">
                            <div className="row">
                                <div className="col-xs-3">
                                    <div className="image">
                                        <img src="images/AmeniFourati.jpg" alt="testimonial pic"/>

                                        <h5>Ameni Fourati </h5>
                                        <span>Happy Customer</span>
                                    </div>
                                </div>
                                <div className="col-xs-9">
                                    <div className="testi-content">
                                        <p>
                                        Un endroit très agréable et convivial où on peut manger en famille . Merci beaucoup au propriétaire pour son accueil chaleureux ainsi qu'à toute l'équipe Bistro 73 qui a fait preuve de professionnalisme . 
                                        </p>
                                        <p className="rating">
                                            <span>Note client:</span>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="item">
                        <div className="testimonial">
                            <div className="row">
                                <div className="col-xs-3">
                                    <div className="image">
                                        <img src="images/DaliHandous.jpg" alt="testimonial pic"/>

                                        <h5>Dali Handous</h5>
                                        <span>Happy Customer</span>
                                    </div>
                                </div>
                                <div className="col-xs-9">
                                    <div className="testi-content">
                                        <p>À conseiller vivement, un accueil chaleureux, une cuisine très riche entre des plats typiquements tunisiens au buffet en plus d'un assortiment varié de salades et un choix varié de plats modernes dans le menu.
La pâtisserie est tout autant délicieuse.
                                        </p>
                                        <p className="rating">
                                            <span>Note client :</span>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="item">
                        <div className="testimonial">
                            <div className="row">
                                <div className="col-xs-3">
                                    <div className="image">
                                        <img src="images/PachaBacha.jpg" alt="testimonial pic"/>

                                        <h5>Pacha Bacha</h5>
                                        <span>Happy Customer</span>
                                    </div>
                                </div>
                                <div className="col-xs-9">
                                    <div className="testi-content">
                                        <p>
                                        De l'entrée au dessert les plats étaient absolument parfaits. Très bon accueil dans le restaurant, d' une sobriété et d' un esthétisme très moderne et très classe avec une bonne explication des plats.
                                        </p>
                                        <p className="rating">
                                            <span>Customer Rating :</span>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="item">
                        <div className="testimonial">
                            <div className="row">
                                <div className="col-xs-3">
                                    <div className="image">
                                        <img src="images/DoniaJeridi.jpg" alt="testimonial pic"/>

                                        <h5>Donia Jeridi</h5>
                                        <span>Happy Customer</span>
                                    </div>
                                </div>
                                <div className="col-xs-9">
                                    <div className="testi-content">
                                        <p>
                                        La bouffe est succulente , top ! J'ai adoré le concept ... merci pour le chaleureux accueil .
                                        </p>
                                        <p className="rating">
                                            <span>Customer Rating :</span>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
  
        <section id="special" className="reservation-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">

                        <h2 className="main-title text-left">
                            <span>Réservez</span>
                        </h2>

                        <div className="sub-title">
                            <p>
                            Réservation possible jusqu’à 72h avant la date de visite, dans la limite des places disponibles..
                            </p>
                        </div>
                        <div className="reserv-form">

                            <div className="row">
                                <div className="col-xs-6 sm-full">
                                    <div className="input-box">
                                        <input type="text" value={this.state.name} onChange={(e=>{

this.setState({name:e.target.value})
})} className="form-control" placeholder="Nom"/>
                                        <span>
                                            <i className="fa fa-pencil"></i>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-xs-6 sm-full">
                                    <div className="input-box">
                                        <input type="text"  value={this.state.phone} onChange={(e=>{

this.setState({phone:e.target.value})
})}
                                         className="form-control" placeholder="Téléphone"/>
                                        <span>
                                            <i className="fa fa-phone"></i>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-xs-6 sm-full">
                                    <div className="input-box">
                                        <input type="text" 
                                        value={this.state.email1} onChange={(e=>{

                                            this.setState({email1:e.target.value})
                                            })} className="form-control" placeholder="Email"/>
                                        <span>
                                            <i className="fa fa-envelope-o"></i>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-xs-6 sm-full">
                                    <div className="input-box">
                                        <input type="date" value={this.state.date} onChange={(e=>{

                                            this.setState({date:e.target.value})
                                            })}  className="form-control" placeholder="Date"/>
                                        <span>
                                            <i className="fa fa-calendar"></i>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-xs-6 sm-full">
                                    <div className="input-box">
                                        <input type="time" value={this.state.time} onChange={(e=>{

this.setState({time:e.target.value})
})} className="form-control" placeholder="Temps"/>
                                        <span>
                                            <i className="fa fa-clock-o"></i>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-xs-6 sm-full">
                                    <div className="input-box pr-40">
                                        <select value={this.state.personnes} onChange={(e=>{this.setState({personnes:e.target.value})})} className="form-control">
                                            <option value="">personnes</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                        </select>
                                        <span>
                                            <i className="fa fa-user"></i>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-xs-12">
                                    <button onClick={()=>this.reserver()} className="btn-submit">réserver une table</button>
                                </div>
                            </div>

                        </div>
           
                    </div>
                   {(this.state.special)? <div  className="col-md-6">
                        <div className="special-box">
                            {(!this.state.special.is_price_hidden)?<span className="price">
                            À partir de  {(this.state.special.price)?this.state.special.price.toFixed(2):0 } TND
                            </span>:<span className=""></span>}
                            <h3>
                                Plat
                                <span> du Jour</span>
                            </h3>
                            <h5>{this.state.special.name}</h5>

                            <p>{this.retournez(this.state.special.description)}</p>
                            <div className="featured-img">
                                <img src={(this.state.special.main_image)?this.state.special.main_image.url:null} alt="todays special dish image"/>
                            </div>
                        </div>  </div>:<div  className="col-md-6">
                        <div className="special-box">
                            <span className="price">
                                12.00 TND
                            </span>
                            <h3>
                                Plat
                                <span> du Jour</span>
                            </h3>
                            <h5>CAESAR SALAD</h5>

                            <p>Lorem ipsum dolor sit amet, con, sectet, uera adipiscing elitan.</p>
                            <div className="featured-img">
                                <img src="images/special-pic.jpg" alt="todays special dish image"/>
                            </div>
                        </div>  </div>}
                  
                </div>

            </div>
        </section>
        
        <section className="newsletter-section section-padding">
            <div className="container">
                <div className="row">
               
                    <div className="col-md-7">
                        <h2 className="newsletter-title ">
                        Abonnez-vous à notre newsletter
                        </h2>
                    </div>
                    <div className="col-md-5">
          {   (this.state.success)?<Alert bsStyle="success">
  <strong>Abonnez avec Succès!</strong> 
</Alert>:null}
                        <div  className="news-form">
                            <i className="fa fa-envelope-o"></i>
                            <input value={this.state.email} type="text" placeholder="Entrez votre adresse email" onChange={(e)=>{this.setState({email:e.target.value,success:false})}} className="form-control"/>
                            <button onClick={()=>{this.send()}} className="btn-submit">Abonnez</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        


<section class=" section-padding">
<div className="container"  >
<div style={{textAlign:"center"}} className="col-md-12">
<h1 style={{color:"#ffad00"}}> Comment ça marche</h1>
</div>
<div style={{textAlign:"center"}} className="col-md-4">
<img height={150} src={step1} />
<h4>Enregistrez ou connectez-vous à votre compte </h4>
    </div>
    <div style={{textAlign:"center"}} className="col-md-4">
    <img style={{marginTop:100}} height={150} src={step2} />
    <h4>Choisissez vos plats </h4>
    </div>
    <div style={{textAlign:"center"}} className="col-md-4">
   
    <img height={150} src={step3} />
    <h4 >Choisissez type de livraison</h4>

    </div>

</div>
</section>

<section class="call-out-backi section-padding">

<div className="container"  >
<div className="col-md-8"  >
<div  style={{marginBottom:0}}  >
<h1 style={{color:"#ffffff",marginBottom:30}}>
                               Obtenez l'application 
                                <span> Bistro 73.</span>
                            </h1>

                            <h2 style={{color:"#ffffff",fontFamily:"Verdana",fontWeight: "normal"}} className="slide-desc">
                            C'est le moyen le plus simple de commander le repas que vous voulez, quand vous le voulez, où que vous soyez.
  </h2>
  </div>
  <div className="container" style={{marginTop:50}} >
<div className="col-md-4" >
<a href="https://play.google.com/store/apps/details?id=project.iobird.menutium.bistro73" target="blank"><img  width={300}  src="images/android.png" alt="android"/></a>
</div>
<div className="col-md-4" >
<a href="https://itunes.apple.com/us/app/bistro73/id1423662149" target="blank"><img   width={300} src="images/IOS.png" alt="IOS"/></a>
</div></div>
              </div>   
              <div className="col-md-4" >
            <img style={{height:350}}  src={BistroPhone}/>
              </div>  </div>        
</section>



<section class=" section-padding">
<div className="container"  >
<div style={{textAlign:"center"}} className="col-md-12">
<h1> Découvrez le Programme de Fidélité sur l'application Bistro73</h1>
<p style={{color:"#000000"}}> Bistro73 propose un programme de fidélité basé sur le cumule de points.<br/>
 Ces points peuvent ensuite ètre convertis en solde utilisable pour effectuer des commandes depuis l'application</p>
</div>



</div>
<div class="container">
<div style={{boxShadow:"0 4px 10px 0 rgba(0,0,0,0.2),0 4px 20px 0 rgba(0,0,0,0.19)"}}>
<br/>
<h4 style={{marginTop:10 }}><i class="fa fa-check" style={{color:"#ffad00",fontSize:25 ,marginRight:10,marginLeft:10}} ></i>Comment ça marche ?</h4>
<p style={{color:"#000000",marginLeft:60}}> Disponible sur l'application mobile (Android,IOS,Web), le programme est accessible dans le menu latéral de votre application. </p>
<h4 style={{marginTop:10 }}><i class="fa fa-check" style={{color:"#ffad00",fontSize:25 ,marginRight:10,marginLeft:10}} ></i>Comment cumuler des point ?</h4>
<p style={{color:"#000000",marginLeft:60}}> Il vous suffit de scanner le QR Code présent dant le ticket restaurant Bistro73 . un écran de félicitation sera affiché pour vous indiquer le nombre de points gagnés. </p>

<h4 style={{marginTop:10 }}><i class="fa fa-check" style={{color:"#ffad00",fontSize:25 ,marginRight:10,marginLeft:10}} ></i>Comment convertir des points ?</h4>
<p style={{color:"#000000",marginLeft:60}}> Dans l'application mobile, vous pouvez consulter le nombre de points et accéder au bouton ou grille de conversion des points en solde. </p>

<br/>


</div>
</div>
</section>
     
       

 
<hr style={{color:"#000000"}} />

       
   

    <ModalConnection ref="ModalConnection"/>

       </div>
   
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/container/home.js